import {
  FETCH_PRODUCT_DETAILS_REQUEST,
  FETCH_PRODUCT_DETAILS_SUCCESS,
  FETCH_PRODUCT_DETAILS_FAILURE,
  FETCH_PRODUCT_DETAILS_RESET,
} from '../../../types/pvs';

const initialState = {
  loading: false,
  error: false,
  success: false,
  message: "",
};

const fetchProductDetailsReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_PRODUCT_DETAILS_REQUEST:
      return Object.assign({}, state, {
        loading: true,
        error: false,
        success: false,
        message: "",
      });

    case FETCH_PRODUCT_DETAILS_SUCCESS:
      return Object.assign({}, state, {
        loading: false,
        success: true,
        error: false,
        message: (action.payload && action.payload.message) || "Product details fetched successfully",
      });

    case FETCH_PRODUCT_DETAILS_FAILURE:
      return Object.assign({}, state, {
        loading: false,
        error: true,
        success: false,
        message: (action.payload && action.payload.error) || "Failed to fetch product details",
      });

    case FETCH_PRODUCT_DETAILS_RESET:
      return Object.assign({}, initialState);

    default:
      return state;
  }
};

export default fetchProductDetailsReducer;
